'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _reduxModulesAuth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_reduxModulesAuth);

var _utilsUtils = require('../../utils/utils');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactisForms = require('reactis-forms');

var _components = {
	_$Login: {
		displayName: 'Login'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Login = (function (_Component) {
	_inherits(Login, _Component);

	_createClass(Login, null, [{
		key: 'contextTypes',
		value: {
			history: _react2['default'].PropTypes.object,
			user: _react2['default'].PropTypes.object
		},
		enumerable: true
	}]);

	function Login() {
		_classCallCheck(this, _Login);

		_Component.call(this);
		this.schema = {
			username: {
				'class': _reactisForms.TextInput,
				label: 'Login',
				placeholder: 'Uživatelské jméno',
				className: 'form-control',
				rules: {
					presence: { message: 'Zadejte přihlašovací jméno!' }
				}
			},
			password: {
				'class': _reactisForms.TextInput,
				type: 'password',
				placeholder: 'Heslo',
				className: 'form-control password',
				label: 'Heslo',
				rules: {
					presence: { message: 'Zadejte heslo!' }
				}
			},
			remember: {
				'class': _reactisForms.Checkbox,
				className: "styled"
			}
		};
	}

	Login.prototype.componentWillMount = function componentWillMount() {
		$(document.body).addClass('login');
		if (this.props.user) {
			this.context.history.replaceState(null, '/');
		}
	};

	Login.prototype.componentWillUnmount = function componentWillUnmount() {
		$(document.body).removeClass('login');
	};

	Login.prototype.handleSubmit = function handleSubmit(form) {
		var values = form.getValues().toJS();
		this.props.login(values);
	};

	Login.prototype.render = function render() {

		return _react2['default'].createElement(
			'div',
			{ className: 'page-container login-container', style: { minHeight: _utilsUtils.getWindowSize().height * 0.9 } },
			_react2['default'].createElement(
				'div',
				{ className: 'page-content' },
				_react2['default'].createElement(
					'div',
					{ className: 'content-wrapper' },
					_react2['default'].createElement(
						_reactisForms.RxForm,
						{ ref: 'form', id: 'login', schema: this.schema, className: 'form-login', onSubmit: this.handleSubmit.bind(this) },
						_react2['default'].createElement(
							'div',
							{ className: 'panel panel-body login-form' },
							_react2['default'].createElement(
								'div',
								{ className: 'text-center' },
								_react2['default'].createElement(
									'div',
									{ className: 'icon-object border-slate-300 text-slate-300' },
									_react2['default'].createElement('i', { className: 'icon-reading' })
								),
								_react2['default'].createElement(
									'h5',
									{ className: 'content-group' },
									'Přihlášení do CRM',
									_react2['default'].createElement(
										'small',
										{ className: 'display-block' },
										'Zadejte uživatelské jméno a heslo.'
									)
								)
							),
							this.props.error && _react2['default'].createElement(
								'div',
								{ className: 'errorHandler alert alert-danger' },
								this.props.error
							),
							_react2['default'].createElement(
								'div',
								{ className: 'form-group has-feedback has-feedback-left' },
								_react2['default'].createElement(_reactisForms.FormField, { name: 'username' }),
								_react2['default'].createElement(
									'div',
									{ className: 'form-control-feedback' },
									_react2['default'].createElement('i', { className: 'icon-user text-muted' })
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: 'form-group has-feedback has-feedback-left' },
								_react2['default'].createElement(_reactisForms.FormField, { name: 'password' }),
								_react2['default'].createElement(
									'div',
									{ className: 'form-control-feedback' },
									_react2['default'].createElement('i', { className: 'icon-lock2 text-muted' })
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: 'form-group login-options' },
								_react2['default'].createElement(
									'div',
									{ className: 'row' },
									_react2['default'].createElement(
										'div',
										{ className: 'col-sm-12' },
										_react2['default'].createElement(
											'label',
											{ className: 'checkbox-inline' },
											_react2['default'].createElement(_reactisForms.FormField, { name: 'remember' }),
											'Pamatovat přihlášení'
										)
									),
									_react2['default'].createElement(
										'div',
										{ className: 'col-sm-6 text-right hide' },
										_react2['default'].createElement(
											'a',
											{ href: 'login_password_recover.html' },
											'Forgot password?'
										)
									)
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: 'form-group' },
								_react2['default'].createElement(
									'button',
									{ type: 'submit', className: 'btn bg-blue btn-block' },
									'Přihlásit ',
									_react2['default'].createElement('i', { className: 'icon-arrow-right14 position-right' })
								)
							)
						)
					)
				)
			),
			_react2['default'].createElement(
				'div',
				{ style: { backgroundColor: '#E4EFEF', padding: '4px 12px', fontSize: 12, position: 'fixed', bottom: 10, right: 10, opacity: 0.6 } },
				_react2['default'].createElement(
					'span',
					{ style: { color: '#444' } },
					'Powered by'
				),
				' ',
				_react2['default'].createElement(
					'a',
					{ target: '_blank', style: { color: '#444' }, href: 'http://www.reactis.cz' },
					'React',
					_react2['default'].createElement(
						'span',
						{ style: { color: '#900' } },
						'is'
					)
				)
			)
		);
	};

	var _Login = Login;
	Login = _wrapComponent('_$Login')(Login) || Login;
	Login = _reactRedux.connect(function (state) {
		return { user: state.auth.user, error: state.auth.loginError };
	}, authActions)(Login) || Login;
	return Login;
})(_react.Component);

exports['default'] = Login;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Login/Login.js
 ** module id = 989
 ** module chunks = 2
 **/